module.exports = __webpack_public_path__ + "static/img/personal.eaa8ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/personal.png
// module id = 36DI
// module chunks = 3